export default __webpack_public_path__ + "static/media/user.e32d3fa7.svg";